import { DashboardOrAnalysisFiltersPreviewTitle } from '@modules/analysis/components/DashboardAndAnalysisFiltersPreview/DashboardOrAnalysisFiltersPreviewTitle';
import { WhereClauseField } from '@modules/common/components/WhereClauseField';
import { WhereClauseFieldProps } from '@modules/common/components/WhereClauseField/WhereClauseField';
import { Button, alpha } from '@mui/material';
import { AnalysisUseCase } from 'generated/graphql';

interface CombinedQuantifyFilterFieldProps extends WhereClauseFieldProps {
  onClear?: () => void;
  customPreviewTitle?: string;
}

export const CombinedQuantifyFilterField = ({
  onClear,
  customPreviewTitle,
  ...props
}: CombinedQuantifyFilterFieldProps) => {
  return (
    <WhereClauseField
      {...props}
      whereClausePreviewProps={{
        headerNode: !props.disableOpenModal && (
          <DashboardOrAnalysisFiltersPreviewTitle
            isDashboardVariant={false}
            analysisUseCase={AnalysisUseCase.Default}
            title={customPreviewTitle}
            secondaryAction={
              !!onClear ? (
                <Button
                  variant="text"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClear();
                  }}
                >
                  Clear
                </Button>
              ) : null
            }
          />
        ),
        sxProps: {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.1),
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          pt: 1,
          py: 0,
          '&:hover': {
            backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.15),
          },
        },
      }}
      addFilterSxProps={{
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.5),
        background: (theme) => alpha(theme.palette.primary.main, 0.1),
        '&:hover': {
          background: (theme) => alpha(theme.palette.primary.main, 0.15),
        },
      }}
    />
  );
};
